<div class="pointer mb-2 flex rounded-2xl border text-blue-950">
  @for (m of metricsInSelector(); track $index; let i = $index; let first = $first) {
    <app-metric-card
      class="flex-1"
      [metric]="m"
      [selectedMetrics]="compatibleSelectedMetrics()"
      [availableMetrics]="availableMetrics()"
      [metricsInSelector]="metricsInSelector()"
      [data]="data()"
      [previousPeriodData]="previousPeriodData()"
      [withPeriodComparison]="showCompare() && !!periodComparison()"
      [loadingPreviousPeriodMetrics]="!!loadingPreviousPeriodMetrics()"
      [shouldRequestSellingPartnerGrant]="shouldRequestSellingPartnerGrant()"
      [isFirst]="first"
      [splitData]="splitData()"
      [previousSplitData]="previousSplitData()"
      [dataLoading]="dataLoading()"
      (clickedMetric)="toggleMetric(m)"
      (removedMetric)="removeMetricFromDropdown(m)"
      (toggledOtherMetricFromMenu)="toggleMetricFromDropdown(i, $event)"
    />
  }
  <button
    class="relative flex flex-col items-center justify-center rounded-r-2xl bg-white p-2 text-xl text-gray-600 hover:text-blue-950"
    [iDropdownMenuTrigger]="metricsMenu"
    placement="bottom-end"
  >
    <IIcon name="plus" />
  </button>
</div>

<ng-template #metricsMenu>
  <app-metrics-menu
    [availableMetrics]="availableMetrics()"
    [isNewMetricSelector]="true"
    [metricsInSelector]="metricsInSelector()"
    (toggleMetric)="toggleMetricFromDropdown(metricsInSelector().length, $event)"
  />
</ng-template>
